import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { VelicinaStav } from './velicina-stav';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-velicina-stav-modal-update',
  templateUrl: './velicina-stav-modal-update.component.html'
})
export class VelicinaStavModalUpdateComponent
 extends BaseModalUpdateComponent<VelicinaStav>{

  constructor(
    protected modalContainerService: ModalContainerService<VelicinaStav>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);

   }


}
